import React from "react";
import Modal from "react-modal";
import { X } from "lucide-react";

const previewModalStyles = {
  overlay: {
    backgroundColor: "rgba(15, 23, 42, 0.55)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    zIndex: 999,
  },
  content: {
    position: "relative",
    inset: "auto",
    border: "none",
    background: "transparent",
    padding: 0,
    borderRadius: 0,
    boxShadow: "none",
    maxWidth: "300px",
    width: "100%",
    margin: 0,
    overflow: "visible",
    maxHeight: "90vh",
  },
};

// Modal wrapper around the phone preview (children) for screens that have no side column.
const PreviewModal = ({ isOpen, onClose, children, t }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onClose}
    style={previewModalStyles}
    contentLabel={t("Profile preview")}
  >
    <div className="relative">
      <button
        onClick={onClose}
        aria-label={t("Close")}
        className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-white shadow-md text-slate-500 flex items-center justify-center transition z-10"
      >
        <X className="w-4 h-4" />
      </button>
      {children}
      <p className="text-center text-xs font-medium text-white/80 mt-4">
        {t("Live preview · updates as you type")}
      </p>
    </div>
  </Modal>
);

export default PreviewModal;
